<template>
   <div class="row">
    <div class="top-bar" @click="closeAll">
      <div class="top-bar-left"><p>User Management List - Personnel</p></div>
      <burger/>
      <div class="top-bar-right">
        <div class="add-user-container">
            <a href="#" class="top-bar-add" @click="showForm()">Add new user</a>
        </div>
        <div class="top-bar-filters">
          <div class="top-bar-filter top-bar-filter-fullheight">
            <div class="container-fluid">
              <search-filter @search="setFilter('query', $event)" />
            </div>
          </div>
          <div class="top-bar-filter top-bar-filter-list">
            <p>Filter:</p>
            <role-filter :type="filters.type" @role="setFilter('type', $event)" />
            <active-filter :active="filters.active" @status="setFilter('active', $event)" />
          </div>
          <!-- <div class="top-bar-filter uml-third-filter">
            <p>Action:</p>

            <div class="dropdown" style="float:left;">
              <button class="dropbtn attendance-dropdown">
                <p><span>Action</span>&nbsp;<i class="fas fa-caret-down"></i></p>
              </button>
              <div class="dropdown-content">
                <a href="#" @click="performAction('Delete')">Delete</a>
                <a href="#" @click="performAction('Activate')" v-if="!filters.active">Activate</a>
                <a href="#" @click="performAction('Deactivate')" v-else>Deactivate</a>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="container-main">
      <div class="container-fluid right-container" data-simplebar id="items-container">
        <div class="left-side">
          <add-user-profile @close="create = false" @saved="getItems(); create = false" v-if="create"/>
          <user-profile :user="user" @close="edit = false" @saved="getItems(); edit = false" v-if="edit"/>
          <v-infinite-scroll :loading="$store.state.loading" @bottom="loadMore" :offset='20' style="max-height: 90vh; overflow-y: scroll; flex: 3;">
            <table class="table items-table">
              <tbody>
                <!-- ITEM -->
                <tr class="item" v-for="(user, key) in users" :key="user.id">
                  <td class="avatar" @click.prevent="showForm(user)">
                    <user-photo :user="user" />
                  </td>
                  <td @click.prevent="showForm(user)">
                    <p>Name</p>
                    <p>{{ user.first_name }} {{ user.last_name }}</p>
                  </td>
                  <td class="col-id" @click.prevent="showForm(user)">
                    <p>ID</p>
                    <p>{{ user.id }}</p>
                  </td>
                  <!-- <td class="col-status" @click="redirect('user-profile', user.id)" @click.prevent="showForm(user)"> -->
                  <td class="col-status" @click.prevent="showForm(user)">
                    <p>Role</p>
                    <div class="row">
                      <div class="col" style="width: 120px">
                        <p :class="`${getType(user.type)}-status`" v-if="user.type && roles">
                          {{ roles[user.type] }}
                        </p>
                      </div>
                      <div class="col">
                        <div :class="`${getType(user.type)}-status-circle`"></div>
                      </div>
                    </div>
                  </td>
                  <td @click.prevent="showForm(user)">
                    <p>Last action</p>
                    <p>{{ moment(user.last_auth).format('MMM DD / h:mm a') }}</p>
                  </td>
                  <td class="col-flag sml-col text-center actions-col">
                    <router-link :to="`/access-logs?user_id=${user.id}`">
                      <img src=".././assets/images/actions.svg" alt="" data-toggle="tooltip" data-placement="bottom" title="Actions">
                      <span><img src=".././assets/images/actions.svg" alt=""> Actions</span>
                    </router-link>
                    <router-link :to="`/events?user_id=${user.id}`">
                      <img src=".././assets/images/alerts_black.svg" alt="" data-toggle="tooltip" data-placement="bottom" title="Events">
                      <span><img src=".././assets/images/alerts_black.svg" alt=""> Events</span>
                    </router-link>
                    <a href="#" @click.prevent="toggleUserActive(key, !user.active)" v-if="!user.active">
                      <img src=".././assets/images/activate.svg" alt="" data-toggle="tooltip" data-placement="bottom" title="Activate">
                      <span><img src=".././assets/images/activate.svg" alt=""> Activate</span>
                    </a>
                    <a href="#"  @click.prevent="toggleUserActive(key, !user.active)" v-else>
                      <img src=".././assets/images/deactivate.svg" alt="" data-toggle="tooltip" data-placement="bottom" title="Deactivate">
                      <span><img src=".././assets/images/deactivate.svg" alt=""> Deactivate</span>
                    </a>
                    <a href="#"  @click.prevent="deleteUser(key)">
                      <img src=".././assets/images/trash.svg" alt="" data-toggle="tooltip" data-placement="bottom" title="Delete">
                      <span><img src=".././assets/images/trash.svg" alt=""> Delete</span>
                    </a>
                  </td>
                  <!-- <td class="text-center">
                    <ul class="unstyled centered">
                      <li>
                        <input class="styled-checkbox" :id="`styled-checkbox-${key}`" type="checkbox" :value="key" v-model="checked">
                        <label :for="`styled-checkbox-${key}`"></label>
                      </li>
                    </ul>
                  </td> -->
                </tr>
              </tbody>
            </table>
          </v-infinite-scroll>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import AddUserProfile from '@/views/AddUserProfile';
  import UserProfile from '@/views/UserProfile';
  import UserPhoto from '@/components/users/Photo';
  import SearchFilter from '@/components/filters/Search';
  import ActiveFilter from '@/components/filters/Active';
  import RoleFilter from '@/components/filters/Role';
  import Burger from '@/components/Burger';

  export default {
    name: 'UserManagement',
    components: {
      AddUserProfile,
      UserPhoto,
      UserProfile,
      SearchFilter,
      ActiveFilter,
      RoleFilter,
      Burger
    },
    data() {
      return {
        create: false,
        edit: false,
        load: true,
        users: [],
        user: {},
        filters: {
          'type': null,
          'active': 1,
          'query': null,
          'start': 0,
          'limit': 20,
        },
        checked: []
      };
    },
    computed: {
      settings() {
        return this.$store.state.settings.data.settings;
      },
      roles() {
        return this.$store.state.settings.data.user_types;
      },
    },
    mounted() {
      this.getItems();
      this.closeUserForm();
    },
    methods: {
      showForm(user = {}) {
        if (Object.keys(user).length) {
          this.user = user;
          this.edit = true;
          this.create = false;

          return;
        }

        this.create = true;
        this.edit = false;
      },
      performAction(currentaction) {
        if (!this.checked.length) {
          return;
        }

        if (confirm(`Are you sure you want to ${currentaction} item?`)) {
          if (currentaction == 'Activate' || currentaction == 'Deactivate') {
            for (let i = 0; i < this.checked.length; i++) {
              this.toggleUserActiveAction(this.checked[i]);
            }
          }

          if (currentaction == 'Delete') {
            // TODO:
            // Warning, not to delete existing user!
            // this.deleteUserAction(this.checked[i]);
          }
        }
      },
      getFilters() {
        let filters = ['loggable=1'];

        window._.forIn(this.filters, function (value, index) {
          if (value != null) {
            filters.push(`${index}=${value}`);
          }
        });

        return filters.join('&');
      },
      getItems() {
        this.load = true;
        this.resetPagination();

        this.axios.get(`/users?${this.getFilters()}`)
          .then(response => {
            if (!response.data.users.length) {
              this.load = false;
            }

            this.users = response.data.users;
          });
      },
      loadMore() {
        if (!this.load) {
          return;
        }

        this.filters.start += (!this.filters.start ? 20 : 10);
        this.filters.limit = 10;

        this.axios.get(`/users?${this.getFilters()}`)
          .then(response => {
            if (!response.data.users.length) {
              this.load = false;
            }

            for (let i in response.data.users) {
              this.users.push(response.data.users[i]);
            }
          });
      },
      toggleUserActive(index) {
        const confirmationMessage = this.users[index].active ?
          'Are you sure you want to deactivate item?' :
          'Are you sure you want to activate item?';

        if(confirm(confirmationMessage)) {
          const activeStatus = this.users[index].active ? 0 : 1;

          const data = {
            user_id: this.users[index].id,
            fields: ["active"],
            values: [activeStatus]
          };

          this.$store.dispatch('users/updateUser', data)
            .then(() => {
              this.users[index].active = activeStatus;
              this.$snotify.success("Active status updated");
            })
            .catch(() => this.$snotify.error('An error occured please try again later.'));
        }
      },
      deleteUser(index) {
        if (confirm('Are you sure you want to delete user?')) {
          this.$store.dispatch('users/deleteUser', {user_id: this.users[index].id})
            .then(() => {
              this.$snotify.success('User successfully deleted!');
              this.users.splice(index, 1);
            })
            .catch(() => this.$snotify.error('An error occured please try again later.'));
        }
      },
      getType(type) {
        const types = {
          1: 'super-admin',
          2: 'admin',
          3: 'security',
          4: 'teacher',
          5: 'student',
          6: 'visitor',
          7: 'unknown'
        };

        return types[type];
      },
    },
  };
</script>
